import Vue from "vue"
import VueRouter from "vue-router"
import chatView from "../views/chat.vue"
import emptyView from "../views/empty.vue"

Vue.use(VueRouter)

const routes = [
	{
		path: "/chat",
		name: "chat",
		component: chatView
	},
	{
		path: "/empty",
		name: "empty",
		component: emptyView
	}
]

const router = new VueRouter({
	mode: "hash",
	base: process.env.BASE_URL,
	routes
})

export default router
